import React from 'react'
import { translate } from 'react-i18next'
import styled from 'styled-components'
import { white } from 'styles/legacyShared/constants/colors'
import { Icon, IconSize } from 'uiComponents/atoms/Icon/Icon'
import { IconName } from 'uiComponents/atoms/Icon/IconName'
import { fsM } from 'uiComponents/constants/typography'

const DiscoverMoreWrapper = styled.div`
  position: absolute;
  right: 150px;
  bottom: 50px;
`

const DiscoverMoreContent = styled.span`
  color: ${white};
  cursor: pointer;
  font-size: ${fsM};
  font-weight: 300;
  letter-spacing: 0.8px;
  padding: 10px;
  position: relative;
  white-space: nowrap;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 5px;
`

function DiscoverMore({ t, onClick }) {
  return (
    <DiscoverMoreWrapper onClick={onClick}>
      <DiscoverMoreContent onClick={onClick}>
        {t('Mehr entdecken')}
        <Icon size={IconSize.XS} asset={IconName.IcChevronDownWhite} />
      </DiscoverMoreContent>
    </DiscoverMoreWrapper>
  )
}

export default translate()(DiscoverMore)
